'use client';

import Avatar from '@/components/next-ui/Avatar';
import { useBreakpointHooks } from '@/utils/break-points.provider';
import getQualifiedImageUrl from '@/utils/imageUrlProcessor';
import Button from '@ui/Button';
import Card from '@ui/Card';
import Typography from '@ui/Typography';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import React, { useEffect } from 'react';
import CreatePostsMenu from './CreatePostsMenu';
import { useCreatePostsStore } from '../../../utils/CreatePostDialogs';
import PostType from '@/constants/postType.constants';
import Dialog from '@/components/next-ui/Dialog';
import Link from '@ui/Link';

const createPostAction = {
  appName: 'createPost',
  label: {
    verb: 'Create Post',
    noun: 'Post',
  },
  icon: '/assets/images/screennav1.png',
  src: '/assets/icons/create-post1.svg',
  alt: 'post',
  checkPermission: false,
};

function PostShortcuts(props) {
  const { firstName, avatar } = props;
  const queryParams = useSearchParams();

  const [showPostsMenu, setShowPostsMenu] = React.useState(false);

  const isLargeScreen = useBreakpointHooks((bp) => bp.useGreater('lg'));

  const openCreatePostDialog = useCreatePostsStore((state) => state.openDialog);

  useEffect(() => {
    if (queryParams.get('action') === 'post-from-template') {
      openCreatePostDialog(PostType.UserPost);
    }
    if (queryParams.get('view') === 'create-from-redirect') {
      handleCreatePostClick();
    }
  }, []);

  const handleClick = () => {
    openCreatePostDialog(PostType.UserPost);
  };

  const handleCreatePostClick = () => {
    if (showPostsMenu) {
      handlePostsMenuClose();
    } else {
      setShowPostsMenu(true);
    }
  };

  const handlePostsMenuClose = () => {
    setShowPostsMenu(false);
  };

  return (
    <Card padding="none" className="px-4 pb-5 pt-4">
      <div className="flex flex-col gap-4 divide-y">
        <div className="flex items-center gap-4 sm:gap-6">
          <Link href="/profile/me">
            <Avatar
              src={getQualifiedImageUrl(avatar)}
              alt={firstName}
              size="md"
            />
          </Link>

          <div
            id="create-a-post"
            className="flex flex-1 flex-nowrap items-center justify-center gap-2.5"
            onClick={() => handleClick()}>
            <div
              className="group flex-1 cursor-pointer rounded-full bg-body-background px-4 py-3 hover:bg-gray-100 sm:px-6 sm:py-5"
              role="button">
              <Typography
                variant="body1"
                className="truncate text-text-primary">
                {`Create a Post`}
              </Typography>
            </div>
            {/* <Button variant="icon" size="lg" onClick={() => handleClick()}>
              <Image
                width={24}
                height={24}
                className="h-6 w-6"
                src={createPostAction.src || ''}
                alt={createPostAction.alt}
              />
            </Button> */}
          </div>
        </div>
        {/* {isLargeScreen && ( */}
        <CreatePostsMenu createPostAction={createPostAction} />
        {/* )} */}
        <Dialog
          isOpen={showPostsMenu}
          title="Create a new"
          maxWidth="sm"
          onClose={handlePostsMenuClose}>
          <CreatePostsMenu
            orientation="vertical"
            onOptionSelect={handlePostsMenuClose}
            onClose={handlePostsMenuClose}
            createPostAction={createPostAction}
          />
        </Dialog>
      </div>
    </Card>
  );
}

export default React.memo(PostShortcuts);
